iScreenWizard.controller('KlantervaringenController', function ($scope, $state, $mdDialog, Ajax, Dictionary, WizardContent, userService) {

    $scope.content = '';
    $scope.user = userService.model;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        refresh();
    });

    var refresh = function() {
        WizardContent.klantervaringen().then(function (klantervaringen) {
            $scope.content = klantervaringen.inhoud;
        });
    };

});